import { DamageTable2 } from 'components/DamageTable2';
import { DAMAGE_LIST_TABLE_ID } from 'components/DamageTable2/utils';
import type { AtlasGqlAssetType } from 'types/atlas-graphql';

type DamageList2Props = {
  tableId?: string;
  title: string;
  damageIds?: string[];
  siteIds?: string[];
  assetIds?: string[];
  assetTypes?: AtlasGqlAssetType[];
  controls?: boolean;
  critical?: boolean;
  savedViews?: boolean;
  externalLoading?: boolean;
};

// TODO JZ: consolidate this with DamageTable2?
export const DamageList2: React.FunctionComponent<DamageList2Props> = ({
  tableId = DAMAGE_LIST_TABLE_ID,
  title = '',
  damageIds,
  siteIds,
  assetIds,
  assetTypes,
  critical,
  controls,
  savedViews,
  externalLoading,
}) => (
  <DamageTable2
    id={tableId}
    data-testid={tableId}
    title={title}
    damageIds={damageIds}
    siteIds={siteIds}
    assetIds={assetIds}
    assetTypes={assetTypes}
    critical={critical}
    controls={controls}
    savedViews={savedViews}
    externalLoading={externalLoading}
  />
);
